import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

/**
 * Visualizador de PDF reutilizável (modal e página). Renderiza um blob URL em
 * <iframe> — o browser exibe o PDF nativamente, sem libs extras. Trata os
 * estados de carregando / erro / vazio.
 */
export default function PdfFrame({ blobUrl, loading = false, error = null, height = 600, titulo = 'Relatório' }) {
    const centro = (conteudo) => (
        <Box sx={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: 1.5, height, bgcolor: '#ECEFF1', borderRadius: 1,
        }}>
            {conteudo}
        </Box>
    );

    if (loading) return centro(<CircularProgress sx={{ color: 'primary.main' }} />);

    if (error) return centro(<Typography color="error">{error}</Typography>);

    if (!blobUrl) return centro(
        <>
            <PictureAsPdfOutlinedIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
            <Typography color="text.secondary">Nenhum relatório gerado ainda.</Typography>
        </>
    );

    return (
        <Box
            component="iframe"
            title={titulo}
            src={blobUrl}
            sx={{
                width: '100%', height, border: 'none', borderRadius: 1,
                bgcolor: '#fff', boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            }}
        />
    );
}
